import { useCallback, useEffect, useState } from "react";
import { getAnnouncement, adminUpdateAnnouncement } from "@/lib/api";
import { toast } from "sonner";

export default function AnnouncementAdmin() {
  const [form, setForm] = useState({ text: "", link_text: "", link_url: "", active: true });

  const load = useCallback(async () => {
    const a = await getAnnouncement();
    if (a && a.text !== undefined) {
      setForm({
        text: a.text || "",
        link_text: a.link_text || "",
        link_url: a.link_url || "",
        active: a.active !== false,
      });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try { await adminUpdateAnnouncement(form); toast.success("Announcement bar updated"); }
    catch { toast.error("Save failed"); }
  };

  return (
    <div className="max-w-3xl" data-testid="admin-announcement">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-wider text-ccc-purple">Public Site</div>
        <h1 className="font-serif text-4xl text-ccc-plum">Announcement Bar.</h1>
      </div>
      <div className="bg-white border border-stone-200 p-6">
        <div className="mb-3">
          <label className="text-xs uppercase tracking-wider text-stone-500 mb-1 block">Message</label>
          <input value={form.text} onChange={e => setForm({...form, text: e.target.value})}
            className="w-full px-3 py-2 border border-stone-300 focus:outline-none focus:border-ccc-purple"/>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs uppercase tracking-wider text-stone-500 mb-1 block">Link text</label>
            <input value={form.link_text || ""} onChange={e => setForm({...form, link_text: e.target.value})}
              className="w-full px-3 py-2 border border-stone-300"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-stone-500 mb-1 block">Link URL</label>
            <input value={form.link_url || ""} onChange={e => setForm({...form, link_url: e.target.value})}
              className="w-full px-3 py-2 border border-stone-300"/>
          </div>
        </div>
        <label className="inline-flex items-center gap-2 mt-4">
          <input type="checkbox" checked={form.active} onChange={e => setForm({...form, active: e.target.checked})}/>
          <span className="text-sm">Active (show at top of every public page)</span>
        </label>
        <div className="mt-6 bg-ccc-plum text-ccc-ivory py-3 px-6 text-sm">
          <span className="font-medium">{form.text}</span>
          {form.link_url && <span className="ml-3 underline text-ccc-gold">{form.link_text || "Learn more"}</span>}
        </div>
        <button onClick={save} className="mt-6 bg-ccc-purple text-white px-6 py-3 uppercase text-sm tracking-wider font-semibold hover:bg-ccc-purple-dark">Save</button>
      </div>
    </div>
  );
}
